import * as StoreDetailsPopup from '../actionTypes/StoreDetailsPopup/storeDetailsPopup'
import Api from '../Api'
import { Config } from '../Config'
import { CommonConstants } from '../Constants'
export const closePopup = () => {
  return {
    type: 'CLOSE_POPUP',
    payload: null
  }
}
export const openPopup = (isAdmin) => {
  return {
    type: 'OPEN_POPUP',
    payload: isAdmin
  }
}
export const mergeClosePopup = () => {
  return {
    type: 'MERGE_CLOSE_POPUP',
    payload: null
  }
}

export const mergeOpenPopup = () => {
  return {
    type: 'MERGE_OPEN_POPUP',
    payload: null
  }
}

export const initModal = (data) => {
  return {
    type: StoreDetailsPopup.INIT_STORE_POPUP,
    payload: data
  }
}

export const initStoreDetail = (suid, isAdmin, callback) => {
  let url = Config.apiBaseUrl + CommonConstants.apiUrls.getStore + '?suid=' + suid
  return (dispatch) => {
    const api = new Api()
    api.getData(url, data => {
      if (data.Device_Details && data.Device_Details[0].Timezone !== undefined) {
        let Timezone = data.Device_Details[0].Timezone
        data.storeDetails.Timezone = Timezone
      } else {
        data.storeDetails.Timezone = null
      }
      dispatch(initModal(data))
      dispatch(openPopup(isAdmin))
      callback()
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/modalAction.js